import { render, staticRenderFns } from "./ReleaseNotes.vue?vue&type=template&id=2d5d2df6&"
import script from "./ReleaseNotes.vue?vue&type=script&lang=ts&"
export * from "./ReleaseNotes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports